<template>
  <v-app>
    <!-- App Bar -->
    <v-app-bar color="primary" density="compact">
      <v-app-bar-nav-icon @click="drawer = !drawer" />
      <v-app-bar-title>
        <div class="d-flex align-center" style="gap: 12px;">
          <img
            src="/nma-logo.svg"
            alt="NMA Logo"
            style="height: 34px; filter: brightness(0) invert(1);"
          />
          <span>{{ $t('app.title') }}</span>
        </div>
      </v-app-bar-title>
      <v-spacer />

      <!-- Company Selector -->
      <template v-if="companyStore.hasCompanies && authStore.isExternalUser">
        <v-select
          v-if="companyStore.hasMultipleCompanies"
          v-model="companyStore.selectedCompanyId"
          :items="companyStore.userCompanies"
          item-title="name"
          item-value="id"
          density="compact"
          variant="solo-filled"
          bg-color="primary-darken-1"
          class="company-select mr-4"
          hide-details
          style="max-width: 220px;"
        />
        <v-chip
          v-else
          class="mr-4"
          color="white"
          variant="outlined"
        >
          {{ companyStore.selectedCompany?.name }}
        </v-chip>
      </template>

      <user-profile />
    </v-app-bar>

    <!-- Navigation Drawer -->
    <v-navigation-drawer v-model="drawer" temporary>
      <v-list>
        <v-list-item prepend-icon="mdi-view-dashboard" :title="$t('navigation.dashboard')" to="/" />
        <v-list-item
          prepend-icon="mdi-package-variant"
          :title="$t('navigation.batchRequests')"
          to="/batch-requests"
        />
        <v-list-item
          prepend-icon="mdi-plus-circle"
          :title="$t('navigation.newRequest')"
          to="/batch-requests/new"
          color="primary"
        />
        <v-divider class="my-2" />
        <v-list-item
          prepend-icon="mdi-file-document-outline"
          :title="$t('navigation.companyDocuments')"
          to="/company-documents"
        />
        <v-list-item
          prepend-icon="mdi-flask"
          :title="$t('navigation.newChemical')"
          to="/chemical-products/new"
        />
        <v-list-item
          prepend-icon="mdi-format-list-bulleted"
          :title="$t('navigation.myChemicals')"
          to="/my-chemicals"
        />
        <v-divider class="my-2" />
        <v-list-item
          prepend-icon="mdi-warehouse"
          :title="$t('navigation.newStorageFacility')"
          to="/storage-facilities/new"
        />
        <v-list-item
          prepend-icon="mdi-warehouse"
          :title="$t('navigation.myStorageFacilities')"
          to="/my-storage-facilities"
        />
        <v-divider class="my-2" />
        <v-list-item
          prepend-icon="mdi-swap-horizontal"
          :title="$t('navigation.transfers')"
          to="/transfers"
        />
      </v-list>
    </v-navigation-drawer>

    <!-- Main Content -->
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useAuthStore } from './stores/authStore'
import { useCompanyStore } from './stores/companyStore'
import { UserProfile } from '@chemtracepro/components'

const authStore = useAuthStore()
const companyStore = useCompanyStore()

const drawer = ref(false)

onMounted(() => {
  authStore.fetchCurrentUser()
})
</script>

<style>
/* Global styles */
html {
  overflow-y: auto;
}
</style>
